import React from "react";
import {
    StyledLegendFirstTitle,
    StyledLegendParagraph,
    StyledLegendHeader,
} from "../../../styles/pages/Schedule/ScheduleStyle";

const LegendHeader = () => {
    return (
        <StyledLegendHeader>
            <StyledLegendFirstTitle>Legenda</StyledLegendFirstTitle>
            <StyledLegendParagraph>
                Visualize abaixo a legenda dos cartões da agenda docente
            </StyledLegendParagraph>
        </StyledLegendHeader>
    );
};

export default LegendHeader;
